/**
 * Extrahiert eine Fehlermeldung aus einem Axios-Error oder gibt die Fallback-Meldung zurück.
 */
export function getAxiosErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const err = error as { response?: { data?: { error?: string } } };
    return err.response?.data?.error ?? fallback;
  }
  return fallback;
}
